import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 6 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L5 5L1 9",
		stroke: "currentColor",
		strokeWidth: .83,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRight;
